<template>
  <div class="bjtp">
    <div>
      <navi></navi>
    </div>
    <div style="padding: 0 270px;margin-top: 100px;" id="zkjgFather">
      <el-row :gutter="20">
        <el-col :span="6">
          <div>
            <div
              style="border: 1px solid #cecece; padding: 20px 20px;background:#f6f8fc;border-radius:10px;height:1000px;overflow-y:auto">
              <span>
                <h2>机构列表</h2>
              </span>
              <div>
                <el-menu :default-active="currentIndexLight" mode="vertical" class="el-menu-vertical-demo"
                  @select="selectMenu" background-color="#f6f8fc" text-color="#202124" active-text-color="#fff"
                  :unique-opened="true">
                  <menu-item v-for="item in organAllSource" :key="item.id" :item="item"></menu-item>
                </el-menu>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div>
            <div
              style="border: 1px solid #cecece;width: 100%; padding: 20px 20px;height: 1000px;background:white;border-radius:10px; ">
              <div style="position:relative;">
                <div style="text-align: center;margin-bottom: 20px">
                  <font class="frinp">
                    <input :placeholder="inputSearch" type="text" v-model="where.search" :disabled="inputDisabled" />
                    <el-button type="primary" size="small" icon="el-icon-search" @click="clickSearch">搜索</el-button>
                  </font>
                </div>
                <template>
                  <el-tabs v-model="activeName" @tab-click="handleTabPaneClick" style="height: 1000px;">
                    <el-tab-pane label="机构简介" name="first" v-if="this.click700 == false" v-loading="loading">
                      <span style="text-align: center;font-size: 20px;color: #256ee5"
                        v-if="introductoryObject.name != null">{{ introductoryObject.name }}({{
                        introductoryObject.chinesename }})</span>
                      <div style="height:888px;overflow-y:auto">
                        <div v-if="introductoryObject.introductory">
                          <div>
                            <el-divider content-position="left">
                              <span class="introductionTitle">机构信息</span>
                            </el-divider>
                            <p style="text-indent: 2em;">{{ introductoryObject.introductory }}</p>
                          </div>
                          <div style="display:flex;justify-content:center;">
                            <!--  -->
                            <div style="border:1px solid #256ee5;width:275px;height:100%;" ref="wikipediaLeft">
                              <div style="display: flex;justify-content:center;margin-top:10px">
                                <img :src="'data:image/png;base64,' + introductoryObject.avatar" width="245"
                                  height="92" />
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="this.wikipedia.xingzhi">
                                <span style="font-weight:bold;width:40%;">机构性质</span>
                                <span style="width:60%;color:#256ee5;">{{ this.wikipedia.xingzhi }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="this.wikipedia.Jurisdiction">
                                <span style="font-weight:bold;width:40%;">管辖权</span>
                                <span style="width:60%;color:#256ee5;">{{ this.wikipedia.Jurisdiction }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="this.wikipedia.Type">
                                <span style="font-weight:bold;width:40%;">类型</span>
                                <span style="width:60%;color:#256ee5;">{{ this.wikipedia.Type }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-show="this.wikipedia.chuangjian">
                                <span style="font-weight:bold;width:40%;">创建</span>
                                <span style="width:60%;">{{ this.wikipedia.chuangjian }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="this.wikipedia.Industry">
                                <span style="font-weight:bold;width:40%;">行业</span>
                                <span style="width:60%;color:#256ee5;">{{ this.wikipedia.Industry }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="this.wikipedia.Headquarters">
                                <span style="font-weight:bold;width:40%;overflow-wrap: break-word;">总部</span>
                                <span style="width:60%;">{{ this.wikipedia.Headquarters }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="this.wikipedia.gaoguan">
                                <span style="font-weight:bold;width:40%;overflow-wrap: break-word;">高管</span>
                                <span style="width:60%;">{{ this.wikipedia.gaoguan }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="this.wikipedia.Parent">
                                <span style="font-weight:bold;width:40%;">上级机构</span>
                                <span style="width:60%;color:#256ee5;">{{ this.wikipedia.Parent }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="this.wikipedia.partner_organization != null">
                                <span style="font-weight:bold;width:40%;overflow-wrap: break-word;">合作机构</span>
                                <span style="width:60%;">{{ this.wikipedia.partner_organization }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="this.wikipedia.product">
                                <span style="font-weight:bold;width:40%;overflow-wrap: break-word;">产品</span>
                                <span style="width:60%;">{{ this.wikipedia.product }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="this.wikipedia.project">
                                <span style="font-weight:bold;width:40%;overflow-wrap: break-word;">项目</span>
                                <span style="width:60%;">{{ this.wikipedia.project }}</span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;" v-if="introductoryObject.url">
                                <div style="font-weight:bold;width:40%;">官网</div>
                                <div style="width:60%;color:#256ee5;overflow-wrap: break-word;">
                                  {{
                                    introductoryObject.url.substring(8, introductoryObject.url.length) }}
                                </div>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="introductoryObject.email">
                                <span style="font-weight:bold;width:40%;">邮箱</span>
                                <span style="width:60%;color:#256ee5;overflow-wrap: break-word;">
                                  {{
                                    introductoryObject.email }}
                                </span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="introductoryObject.phone">
                                <span style="font-weight:bold;width:40%;">电话</span>
                                <span style="width:60%;color:#256ee5;overflow-wrap: break-word;">
                                  {{
                                    introductoryObject.phone }}
                                </span>
                              </div>
                              <div style="display: flex;padding:5px 15px;font-size:14px;"
                                v-if="introductoryObject.socialcontact">
                                <div style="font-weight:bold;width:40%;">
                                  <span>社交媒体</span>
                                </div>
                                <div style="width:60%;display:flex;flex-wrap: wrap;">
                                  <div v-for="(socialItem, socialIndex) in introductoryObject.socialcontact"
                                    :key="socialIndex" :title="socialItem" style="margin-right: 15px;">
                                    <svg v-if="extractSocial(socialItem) == 'facebook'" t="1672392387063" class="icon"
                                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                      p-id="2681" width="25" height="25">
                                      <path
                                        d="M1024 512c0-282.763636-229.236364-512-512-512C229.236364 0 0 229.236364 0 512s229.236364 512 512 512C794.763636 1024 1024 794.763636 1024 512zM374.504727 512 374.504727 414.021818l60.043636 0L434.548364 354.769455c0-79.918545 23.877818-137.495273 111.383273-137.495273l104.075636 0 0 97.745455-73.262545 0c-36.724364 0-45.056 24.389818-45.056 49.943273l0 49.058909 112.919273 0L629.201455 512l-97.512727 0 0 295.517091L434.548364 807.517091 434.548364 512 374.504727 512z"
                                        p-id="2682" fill="#1296db" />
                                    </svg>
                                    <svg v-if="extractSocial(socialItem) == 'twitter'" t="1672392886052" class="icon"
                                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                      p-id="6737" width="25" height="25">
                                      <path
                                        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m215.3 337.7c0.3 4.7 0.3 9.6 0.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2-50.8-10.3-88.9-55-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1-30.9-20.6-49.5-55.3-49.5-92.4 0-20.7 5.4-39.6 15.1-56 54.7 67.4 136.9 111.4 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                                        fill="#1296DB" p-id="6738" />
                                    </svg>
                                    <svg v-if="extractSocial(socialItem) == 'linkedin'" t="1672392719131" class="icon"
                                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                      p-id="5164" width="25" height="25">
                                      <path
                                        d="M512 1024C229.2224 1024 0 794.7776 0 512 0 229.2224 229.2224 0 512 0c282.7776 0 512 229.2224 512 512 0 282.7776-229.2224 512-512 512z m-137.762133-286.378667V397.380267h-102.4V737.621333h102.4z m-51.2-488.448c-33.024 0-54.5792 22.954667-53.9136 53.589334-0.682667 29.218133 20.8896 52.872533 53.248 52.872533 33.672533 0 55.2448-23.6544 55.2448-52.8896-0.682667-30.6176-21.572267-53.572267-54.5792-53.572267z m133.410133 488.448h102.4V541.405867c0-9.728 1.365333-20.1728 4.061867-26.453334 6.724267-19.456 23.569067-39.645867 51.882666-39.645866 37.034667 0 51.882667 29.917867 51.882667 73.762133V737.621333h102.4V535.842133c0-100.181333-50.517333-146.1248-117.9136-146.1248-54.562133 0-88.251733 32.7168-101.7344 54.272h-2.030933l-4.7104-46.609066h-88.9344c1.348267 29.917867 2.696533 66.0992 2.696533 108.544V737.621333z"
                                        fill="#0073B1" p-id="5165" />
                                    </svg>
                                    <svg v-if="extractSocial(socialItem) == 'instagram'" t="1672392782285" class="icon"
                                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                      p-id="6180" width="25" height="25">
                                      <path
                                        d="M512.1 282c-127.2 0-229.8 102.6-229.8 229.8s102.6 229.8 229.8 229.8S741.9 639 741.9 511.8 639.3 282 512.1 282z m0 379.2c-82.2 0-149.4-67-149.4-149.4s67-149.4 149.4-149.4 149.4 67 149.4 149.4-67.2 149.4-149.4 149.4z m292.8-388.6c0 29.8-24 53.6-53.6 53.6-29.8 0-53.6-24-53.6-53.6s24-53.6 53.6-53.6 53.6 24 53.6 53.6z m152.2 54.4c-3.4-71.8-19.8-135.4-72.4-187.8-52.4-52.4-116-68.8-187.8-72.4-74-4.2-295.8-4.2-369.8 0-71.6 3.4-135.2 19.8-187.8 72.2s-68.8 116-72.4 187.8c-4.2 74-4.2 295.8 0 369.8 3.4 71.8 19.8 135.4 72.4 187.8s116 68.8 187.8 72.4c74 4.2 295.8 4.2 369.8 0 71.8-3.4 135.4-19.8 187.8-72.4 52.4-52.4 68.8-116 72.4-187.8 4.2-74 4.2-295.6 0-369.6zM861.5 776c-15.6 39.2-45.8 69.4-85.2 85.2-59 23.4-199 18-264.2 18s-205.4 5.2-264.2-18c-39.2-15.6-69.4-45.8-85.2-85.2-23.4-59-18-199-18-264.2s-5.2-205.4 18-264.2c15.6-39.2 45.8-69.4 85.2-85.2 59-23.4 199-18 264.2-18s205.4-5.2 264.2 18c39.2 15.6 69.4 45.8 85.2 85.2 23.4 59 18 199 18 264.2s5.4 205.4-18 264.2z"
                                        p-id="6181" fill="#d81e06" />
                                    </svg>
                                    <svg v-if="extractSocial(socialItem) == 'youtube'" t="1672393052466" class="icon"
                                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                      p-id="7779" width="25" height="25">
                                      <path
                                        d="M941.3 296.1c-10.3-38.6-40.7-69-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7C123.3 227 93 257.4 82.7 296 64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z"
                                        p-id="7780" fill="#d81e06" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- 维基百科信息 -->
                            <div v-if="this.introductoryObject.wikipedia">
                              <div v-if="this.wikipedia.rightImage"
                                style="display:flex;flex-direction:column;margin-left:30px;height:100%;">
                                <img :src="'data:image/png;base64,' + this.wikipedia.rightImage" alt
                                  :style="{ width: 500 + 'px', height: imgHeight + 'px' }" @load="onImgLoad" />
                                <span style="width:500px;" ref="wikipediaLeftBottom">
                                  {{ this.wikipedia.rightContext
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <!-- 历史 -->
                          <div v-if="this.wikipedia.history">
                            <div style="padding-left: 30px;font-size: 16px;font-weight:bold;margin-bottom:10px;">历史背景
                            </div>
                            <div style="text-indent: 2em;">{{ this.wikipedia.history }}</div>
                          </div>
                          <div v-if="this.wikipedia.capital">
                            <div style="padding-left: 30px;font-size: 16px;font-weight:bold;">资金预算</div>
                            <div>
                              <p style="text-indent: 2em;">{{ this.wikipedia.capital }}</p>
                            </div>
                          </div>
                        </div>
                        <div v-if="introductoryObject.information">
                          <el-divider content-position="left">
                            <span class="introductionTitle">涉华因素</span>
                          </el-divider>
                          <div class="over1" style="max-height:500px;width:99%;overflow:auto;">
                            <div v-for="(item, index) in this.information" :key="index">
                              <div>
                                <div style="font-weight: bold;margin:10px 0;">《{{ item.title }}》</div>
                              </div>
                              <div>
                                <span style="padding:0 10px;color:#46c6e6;">{{ item.date }} 出版</span>
                                <div v-html="item.context"
                                  style="font-weight: 200;white-space: pre-wrap;padding:0 10px;color:#afb3b4;margin-top:10px;">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- 热点事件 -->
                        <div v-show="introductoryObject.hotEvent">
                          <el-divider content-position="left">
                            <span class="introductionTitle">热点事件</span>
                          </el-divider>
                          <div>
                            <div style="margin:15px 0 15px 30px;width:800px;">
                              <div style="margin: 10px 0;" v-for="(item, index) in this.hotEvent" :key="index">
                                <div style="display: flex;">
                                  <div>
                                    <div style="color:#256ee5;">{{ item.title }}</div>
                                    <div
                                      style="margin:10px 0;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                                      {{ item.context }}</div>
                                  </div>
                                  <div>
                                    <img :src="getImageSrc(item.image)" alt :onerror="defaultImg" width="92"
                                      height="92" />
                                  </div>
                                </div>
                                <div style="color:#afb3b4;">{{ item.date }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="机构成员" name="second" v-if="this.click700 == false" v-loading="loading">
                      <div>
                        <div class="zdry_label">
                          <div class="zcdt_l_right">
                            <table>
                              <tr v-for="(p, index) in this.organPersons" @click="rwxq(p.id)">
                                <td>
                                  <img :src="'data:image/png;base64,' + p.imgcode" alt :onerror="defaultImg" />
                                </td>
                                <td style="padding-left: 20px">
                                  <span style="font-size: 20px">{{ p.name }}</span>
                                  <span class="huaTitle" v-if="p.ishua == 1">涉华</span>
                                  <br />
                                  {{ p.address }}
                                  <br />
                                  <span style="color: #a0a0a0">{{ p.position }}</span>
                                  <span v-if="p.industry" style="color: #a0a0a0">,{{ p.industry }}</span>
                                </td>
                              </tr>
                              <tr v-if="this.organPersons.length <= 0">
                                <!-- <td>无该机构人员</td> -->
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div style="text-align: center;margin-top: 20px;display:flex;justify-content:center;"
                          v-if="this.organPersons.length != 0">
                          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                            :current-page.sync="where.page" :page-size="5" :total="total"></el-pagination>
                          <!-- <div style="display: flex;align-items:center;">发现 <span style="color: #256ee5;">{{ total}}</span>成员</div> -->
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="涉华重点" name="third" v-if="this.click700 == false" v-loading="loading">
                      <div>
                        <div class="zdry_label">
                          <div class="zcdt_l_right">
                            <table>
                              <tr v-for="(p, index) in this.organPersons" :key="index" @click="rwxq(p.id)">
                                <td>
                                  <img :src="'data:image/png;base64,' + p.imgcode" alt :onerror="defaultImg" />
                                </td>
                                <td style="padding-left: 20px">
                                  <span style="font-size: 20px">{{ p.name }}</span>
                                  <span class="huaTitle">涉华</span>
                                  <br />
                                  {{ p.address }}
                                  <br />
                                  <span style="color: #a0a0a0">{{ p.position }}</span>
                                  <span v-if="p.industry" style="color: #a0a0a0">,{{ p.industry }}</span>
                                </td>
                              </tr>
                              <tr v-if="this.organPersons.length <= 0">
                                <!-- <td>无涉华人员</td> -->
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div style="text-align: center;margin-top: 20px;display:flex;justify-content:center;"
                          v-if="this.organPersons.length != 0">
                          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                            :current-page.sync="where.page" :page-size="5" :total="total"></el-pagination>
                          <!-- <div style="display: flex;align-items:center;">发现 <span style="color: #256ee5;">{{ total}}</span>涉华成员</div> -->
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane :label="countLabel" disabled v-if="this.organPersons.length != 0 && this.stateId != 0"
                      tab-position="right" id="tabFour"></el-tab-pane>
                  </el-tabs>
                </template>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 20px;">
      <foot></foot>
    </div>
  </div>
</template>

<script>
import navi from "../components/navi";
import foot from "../components/foot";

//引入方法
import {
  selectAllSource,
  selectIntroductoryById,
  pageOrgan,
  pageHuaOrgan,
  getPeopleList
} from "@/api/organization";
import { width } from "dom7";
export default {
  name: "zygw",
  components: {
    navi,
    foot
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      activeName: "first",
      currentIndexLight: "75", //当前激活菜单的 index  高亮显示
      filterText: "",
      stateId: 0, //0：官网简介 1：人员 2：发文
      organAllSource: [],
      introductoryObject: {}, //点击左侧查询出来的对象
      where: { page: 1, companyId: "0", search: null }, //全局条件带分页
      organPersons: [], //人员
      defaultImg:
        'this.src="' + require("../../static/images/defult_head.png") + '"', //没有图片则展示这个
      total: 0, //多少条数
      inputSearch: null, //搜索框提示词
      inputDisabled: true, //是否禁用搜索框
      wikipediaHeight: 200,
      defaultProps: {
        children: "children",
        label: "label"
      },
      information: [],
      hotEvent: [],
      wikipedia: {}, //点击左侧查询出来的对象
      countLabel: "发现多少人员",
      imgHeight: 0,
      loading: true,
      click700: false
    };
  },
  created() {
    // console.log("路由接受到的参数",this.$route.params.companyId)
    if (this.$route.query.companyId != undefined) {
      this.currentIndexLight = this.$route.query.companyId;
    }
    this.selectAllSource();
  },
  methods: {
    getImageSrc(base64Str) {
      if (!base64Str) return '';

      // 检查 Base64 字符串的前几位
      // JPG 通常以 /9j/ 开头
      if (base64Str.startsWith('/9j/')) {
        return 'data:image/jpeg;base64,' + base64Str;
      }
      // PNG 通常以 iVBORw0KGgo 开头
      else if (base64Str.startsWith('iVBORw0KGgo')) {
        return 'data:image/png;base64,' + base64Str;
      }
      // 如果都不匹配，默认尝试 jpeg 或者 png
      else {
        return 'data:image/jpeg;base64,' + base64Str;
      }
    },
    onImgLoad() {
      this.imgHeight =
        this.$refs.wikipediaLeft.offsetHeight -
        this.$refs.wikipediaLeftBottom.offsetHeight;
    },
    extractSocial(str) {
      let newStr = null;
      if (str.indexOf("instagram") > 0) {
        newStr = "instagram";
      }

      if (str.indexOf("facebook") > 0) {
        newStr = "facebook";
        // console.log("facebook", str, "---" + str.indexOf("facebook"));
      }

      if (str.indexOf("twitter") > 0) {
        newStr = "twitter";
        // console.log("twitter", str, "---" + str.indexOf("twitter"));
      }

      if (str.indexOf("linkedin") > 0) {
        newStr = "linkedin";
      }

      if (str.indexOf("youtube") > 0) {
        newStr = "youtube";
      }
      return newStr;
    },
    //点击左侧列表发生的改变
    selectMenu(key, keyPath) {
      // console.log(key, keyPath)
      if (key >= 700) {
        this.activeName = "fourthly";
        this.stateId = 4;
        this.click700 = true;
      } else {
        if (this.stateId == 1) {
          this.activeName = "second";
          this.stateId = 1;
        } else if (this.stateId == 2) {
          this.activeName = "third";
          this.stateId = 2;
        } else {
          this.activeName = "first";
          this.stateId = 0;
        }
        this.click700 = false;
      }

      this.currentIndexLight = key;
      this.where.companyId = key;
      this.where.page = 1; //代表点击左侧之后重置当前页
      this.where.search = null;
      // console.log("tab",this.where.page)
      if (this.stateId == 1 || this.stateId == 4) {
        this.pageSearch();
      } else if (this.stateId == 2) {
        this.pageHuaOrgan();
      } else {
        this.selectIntroductory(key);
      }
    },

    //点击右侧三个标头
    handleTabPaneClick(tab, event) {
      this.loading = true;
      // console.log(tab,event);
      this.where.page = 1; //代表点击标头之后重置当前页
      // console.log("tab", this.where.page)
      if (tab.name == "second" || tab.name == "fourthly") {
        //人员
        this.stateId = 1;
        this.inputSearch = "请输入姓名/地址/职位/行业";
        this.inputDisabled = false;
        this.where.search = null;
        this.pageSearch(this.where);
      } else if (tab.name == "third") {
        //涉hua人员
        this.stateId = 2;
        this.inputSearch = "请输入姓名/地址/职位/行业";
        this.inputDisabled = false;
        this.where.search = null;
        this.pageHuaOrgan(this.where);
      } else {
        //简介
        this.stateId = 0;
        this.inputSearch = null;
        this.inputDisabled = true;
        this.where.search = null;
        this.selectIntroductory(this.where.companyId);
      }
    },

    async selectAllSource() {
      //const reponse = await selectAllSource();
      // console.log('selectAllSource', reponse);
      this.organAllSource = [{"children":[{"children":[{"children":[{"children":null,"id":"75","label":"外交贸易部"},{"children":null,"id":"76","label":"澳大利亚驻东京大使馆"},{"children":null,"id":"77","label":"澳大利亚驻韩国大使馆"},{"children":null,"id":"78","label":"澳大利亚高级专员公署"},{"children":null,"id":"79","label":"澳大利亚台北办事处"},{"children":null,"id":"80","label":"澳大利亚驻香港总领事馆"}],"id":"外交部门","label":"外交部门"},{"children":[{"children":null,"id":"81","label":"澳大利亚安全情报局"},{"children":null,"id":"82","label":"澳大利亚国防情报组织"},{"children":null,"id":"83","label":"澳大利亚信号局"},{"children":null,"id":"84","label":"澳大利亚国家情报办公室"},{"children":null,"id":"85","label":"澳大利亚交易报告分析中心"},{"children":null,"id":"113","label":"澳大利亚地理空间情报组织"},{"children":null,"id":"114","label":"澳大利亚秘密情报局"}],"id":"澳大利亚情治机构","label":"澳大利亚情治机构"},{"children":[{"children":null,"id":"86","label":"澳大利亚皇家海军"},{"children":null,"id":"87","label":"澳大利亚陆军"},{"children":null,"id":"88","label":"澳大利亚皇家空军"},{"children":null,"id":"89","label":"澳大利亚国防军"},{"children":null,"id":"90","label":"澳大利亚国防部"},{"children":null,"id":"91","label":"澳大利亚退伍军人事务部"},{"children":null,"id":"92","label":"澳大利亚卫生部军事和紧急服务部"},{"children":null,"id":"93","label":"澳大利亚国防学院"}],"id":"澳军事部门","label":"澳军事部门"},{"children":[{"children":null,"id":"94","label":"澳大利亚联邦银行"},{"children":null,"id":"95","label":"澳大利亚财政部"},{"children":null,"id":"96","label":"澳大利亚贸易委员会"},{"children":null,"id":"97","label":"澳大利亚贸易与投资"},{"children":null,"id":"98","label":"麦格理集团有限公司"},{"children":null,"id":"99","label":"澳大利亚税务局"},{"children":null,"id":"100","label":"澳大利亚军事银行"},{"children":null,"id":"101","label":"澳大利亚储备银行"},{"children":null,"id":"102","label":"澳大利亚国民银行"},{"children":null,"id":"103","label":"西太平洋银行"}],"id":"银行机构","label":"银行机构"},{"children":[{"children":null,"id":"104","label":"澳大利亚议会"},{"children":null,"id":"105","label":"澳大利亚司法部"},{"children":null,"id":"106","label":"澳大利亚首相及内阁部"},{"children":null,"id":"107","label":"澳大利亚内政部"},{"children":null,"id":"108","label":"社会服务部"},{"children":null,"id":"109","label":"澳大利亚高等法院"},{"children":null,"id":"110","label":"澳大利亚联邦法院"},{"children":null,"id":"111","label":"澳大利亚联邦警察局"}],"id":"其他政府机构","label":"其他政府机构"}],"id":"政府机构","label":"政府机构"},{"children":[{"children":null,"id":"24","label":"悉尼大学"},{"children":null,"id":"25","label":"昆士兰大学"},{"children":null,"id":"26","label":"澳大利亚洛伊研究所"},{"children":null,"id":"27","label":"澳大利亚公共事务研究所"},{"children":null,"id":"28","label":"澳大利亚悉尼大学美国研究中心"},{"children":null,"id":"30","label":"澳大利亚东亚论坛"},{"children":null,"id":"31","label":"澳大利亚战略与国防研究中心"},{"children":null,"id":"32","label":"澳大利亚经济发展委员会"},{"children":null,"id":"33","label":"澳大利亚独立研究中心"},{"children":null,"id":"34","label":"亚洲教育基金会"},{"children":null,"id":"35","label":"超越零排放"},{"children":null,"id":"37","label":"澳大利亚区域安全研究所"},{"children":null,"id":"38","label":"澳大利亚经济与和平研究所"},{"children":null,"id":"39","label":"澳大利亚中国关系学院"},{"children":null,"id":"40","label":"伯内特研究所"},{"children":null,"id":"41","label":"澳大利亚悉尼研究所"},{"children":null,"id":"42","label":"墨尔本学院"},{"children":null,"id":"43","label":"澳大利亚珀斯美国中心"},{"children":null,"id":"45","label":"昆士兰孟席斯健康研究所"},{"children":null,"id":"47","label":"格里菲斯药物发现研究所"},{"children":null,"id":"48","label":"澳大利亚河流研究所"},{"children":null,"id":"49","label":"澳大利亚格里菲斯亚洲研究所"},{"children":null,"id":"50","label":"悉尼环境研究所"},{"children":null,"id":"51","label":"麦凯尔研究所"},{"children":null,"id":"52","label":"社会研究中心"},{"children":null,"id":"53","label":"全球CCS研究所"},{"children":null,"id":"54","label":"澳大利亚发展政策中心"},{"children":null,"id":"73","label":"澳大利亚战略政策研究所"},{"children":null,"id":"112","label":"澳大利亚珍珠与刺激智库"}],"id":"智库","label":"智库"},{"children":[{"children":null,"id":"58","label":"澳大利亚霍克布赖顿集团公司"},{"children":null,"id":"60","label":"澳大利亚巴顿迪肯公司"}],"id":"咨询公司","label":"咨询公司"},{"children":[{"children":null,"id":"63","label":"澳大利亚国防承包商SYPAQ公司"}],"id":"安全及防务承包商","label":"安全及防务承包商"},{"children":[{"children":null,"id":"66","label":"澳大利亚人报"},{"children":null,"id":"67","label":"澳大利亚战略家"},{"children":null,"id":"68","label":"澳大利亚悉尼先驱晨报"}],"id":"媒体","label":"媒体"}],"id":"澳大利亚","label":"澳大利亚"},{"children":[{"children":[{"children":null,"id":"56","label":"新西兰外交贸易部"},{"children":null,"id":"57","label":"新西兰国防部"}],"id":"政府机构","label":"政府机构"},{"children":[{"children":null,"id":"59","label":"新西兰游说公司"}],"id":"咨询公司","label":"咨询公司"},{"children":[{"children":null,"id":"61","label":"新西兰火箭研究室"},{"children":null,"id":"62","label":"新西兰国防承包商Skycam公司"}],"id":"安全及防务承包商","label":"安全及防务承包商"},{"children":[{"children":null,"id":"64","label":"新西兰先驱报"},{"children":null,"id":"65","label":"新西兰媒体STUFF"}],"id":"媒体","label":"媒体"},{"children":[{"children":null,"id":"8","label":"魔途"},{"children":null,"id":"16","label":"银研"},{"children":null,"id":"17","label":"环境科学研究所"},{"children":null,"id":"18","label":"地质与核科学研究所"},{"children":null,"id":"19","label":"土地保护研究"},{"children":null,"id":"20","label":"国家水与大气研究所"},{"children":null,"id":"21","label":"植物与食品研究"},{"children":null,"id":"22","label":"赛恩"},{"children":null,"id":"55","label":"新西兰国际事务研究院"},{"children":null,"id":"69","label":"新西兰智库外交圈"},{"children":null,"id":"70","label":"新西兰经济研究所"},{"children":null,"id":"71","label":"新西兰国防和安全研究中心"},{"children":null,"id":"72","label":"新西兰当代中国研究中心"}],"id":"智库","label":"智库"}],"id":"新西兰","label":"新西兰"}];
      // console.log('selectAllSourcess', reponse.data[0].children[0].id);

      if (this.$route.query.companyId == undefined) {
        // const reponse1 = await selectIntroductoryById(reponse.data[0].children[0].id);
        const reponse1 = await selectIntroductoryById(75);
        // console.log('reponse', reponse1);
        //给简介赋值
        // this.where.companyId = reponse.data[0].children[0].id;
        this.where.companyId = 75;
        this.introductoryObject = reponse1.data;
      } else {
        const reponse1 = await selectIntroductoryById(
          this.$route.query.companyId
        );
        // console.log('reponse', reponse1);
        //给简介赋值
        this.where.companyId = this.$route.query.companyId;
        this.introductoryObject = reponse1.data;
      }
      this.splitIntroductory();
      this.loading = false;
      // console.log("introductoryObject", this.introductoryObject);
    },

    async selectIntroductory(id) {
      const reponse = await selectIntroductoryById(id);
      this.introductoryObject = reponse.data;
      // console.log('selectIntroductory', reponse);
      this.splitIntroductory();
      this.loading = false;
    },
    async getPeopleList() {
      const reponse = await getPeopleList(this.peopleId);
      // this.introductoryObject = reponse.data;
      // this.peopleId = reponse.data.peopleid;
      // console.log('getPeopleList', reponse);
    },

    splitIntroductory() {
      if (this.introductoryObject.information != null) {
        // this.introductoryObject.information = JSON.stringify(this.introductoryObject.information);
        let informations = JSON.parse(this.introductoryObject.information);
        // let informations = JSON.parse(this.introductoryObject.information.replace(/<b>/g, '').replace(reg, ''));
        // this.introductoryObject.information =eval("(" + this.introductoryObject.information + ")");
        this.information = informations.list;
        // this.sortKey(this.information, "date").then(data => {
        //   this.information = data;
        // });
        // console.log(this.information);
        // console.log(this.information.length);
      }
      if (this.introductoryObject.hotEvent != null) {
        let hotEvent = JSON.parse(this.introductoryObject.hotEvent);
        this.hotEvent = hotEvent.list;
        // this.sortKey(this.hotEvent, "date").then(data => {
        //   this.hotEvent = data;
        // });
        // console.log(this.hotEvent);
        // console.log(this.hotEvent.length);
      }
      if (this.introductoryObject.wikipedia != null) {
        let wikipedia = JSON.parse(this.introductoryObject.wikipedia);
        this.wikipedia = wikipedia;
        // console.log('wikipedia', this.wikipedia);
      } else {
        this.wikipedia = {};
      }
      // if (this.introductoryObject.phone != null) {
      //   this.introductoryObject.phone = this.introductoryObject.phone.split(',');
      // }
      // if (this.introductoryObject.email != null) {
      //   this.introductoryObject.email = this.introductoryObject.email.split(',');
      // }
      if (this.introductoryObject.socialcontact != null) {
        this.introductoryObject.socialcontact = this.introductoryObject.socialcontact.split(
          ","
        );
        // console.log("socialcontact", this.introductoryObject.socialcontact);
      }
    },
    //倒序
    async sortKey(array, key) {
      return await array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x < y ? 1 : 0;
      });
    },
    async pageSearch() {
      var response = await pageOrgan(this.where);
      this.organPersons = response.data;
      this.total = response.count;
      this.countLabel = "发现" + this.total + "成员";
      this.loading = false;
      // console.log('pageSearch', this.activeName)
      // console.log('pageSearch', response)
    },
    async pageHuaOrgan() {
      var response = await pageHuaOrgan(this.where);
      this.organPersons = response.data;
      this.total = response.count;
      this.countLabel = "发现" + this.total + "涉华成员";
      this.loading = false;
      // console.log('pageHuaOrgan', response)
    },

    handleCurrentChange(page) {
      this.where.page = page;
      if (this.stateId == 1 || this.stateId == 4) {
        this.pageSearch();
      } else if (this.stateId == 2) {
        this.pageHuaOrgan();
      }
    },
    // 跳转详情
    rwxq(id) {
      let routeData = this.$router.resolve({
        path: "/rwxq",
        query: { personid: id }
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: 'rwxq', params: { personid: id } })
    },
    //点击检索
    async clickSearch() {
      // console.log('检索', this.where.search);
      if (this.stateId == 1) {
        this.pageSearch();
      } else if (this.stateId == 2) {
        this.pageHuaOrgan();
      }
    },
    renderContent(h, { node, data, store }) {
      // console.log("h",h);
      // console.log("node",node);
      // console.log("data",data);
      // console.log("store",store);
      if (data.type == 0) {
        // return <span style="color:#104081">{node.label}</span>;
        return <span style="color:#1a4acb">{node.label}</span>;
        // return <span style="color:#3b65ac">{node.label}</span>;
      } else {
        return <span style="color:#303133">{node.label}</span>;
        // return <span style="color:#27a6a7">{node.label}</span>;
      }
    },
    filterNode(value, organAllSource) {
      if (!value) return true;
      return organAllSource.label.indexOf(value) !== -1;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ #tab-1 {
  margin-left: 772px !important;
  color: #256ee5 !important;
}

/deep/ #tab-3 {
  margin-left: 580px !important;
  color: #256ee5 !important;
}

// * 修改导航菜单栏悬浮时的背景颜色
#zkjgFather /deep/.el-menu {
  border: 0;
}

#zkjgFather /deep/.el-menu .el-submenu__title {
  font-size: 15px;
}

#zkjgFather /deep/.el-menu .el-menu-item:hover {
  //子菜单
  outline: 0 !important;
  background: #d3e3fd !important;
  color: rgb(0, 0, 0) !important;
  font-weight: bold !important;
  // background: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%)!important;
}

#zkjgFather /deep/.el-menu .el-menu-item.is-active {
  color: rgb(255, 255, 255) !important;
  background: #3f5d73 !important;
  // color: #2E95FB !important;
  // background: #3f5d73 !important;
  // background: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%) !important;
}

#zkjgFather /deep/.el-menu .el-submenu .el-submenu__title:hover {
  // 父级菜单
  background: #d3e3fd !important;
  color: rgb(0, 0, 0) !important;
  font-weight: bold !important;
  // background: linear-gradient(270deg, #F2F7FC 0%, #FEFEFE 100%)!important;
}

.bjtp {
  overflow-x: hidden;
  min-height: 800px;
  background: linear-gradient(to bottom,
      #3f48cc 0%,
      #3f48cc 285px,
      #f0f8ff 285px,
      #f0f8ff 100%);
  // background: url(../../static/images/background.png);
  // background-size: contain;
}

.el-icon-s-unfold /deep/ span {
  color: red !important;
}

/* 改变被点击节点背景颜色，字体颜色 */
.filter-tree /deep/ .el-tree-node .el-tree-node__content:hover {
  background-color: #66b1ff87;
}

.filter-tree /deep/ .el-tree-node .el-tree-node__content {
  // color: red;
}

.filter-tree /deep/ .el-tree-node {
  padding-bottom: 5px;
}

.introductionTitle {
  font-size: 20px;
  font-weight: bold;
}

.huaTitle {
  line-height: 14px;
  display: inline-block;
  border: 1px solid rgb(90, 114, 235);
  padding: 2px 12px;
  border-radius: 11px;
  color: rgb(90, 114, 235);
  margin-left: 15px;
  font-size: 12px;
}

.frinp input {
  width: 60%;
  height: 29px;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  padding-left: 10px;
  outline: 0;
}

.frinp input:focus {
  /* border: 1px solid #51dce6; */
  box-shadow: 0px 0px 12px 0px #6f6c74;
  border: 1px solid #6f6c74;
}

.search-button {
  height: 33px;
  background: #3f48cc;
  border: 0px;
  border-radius: 10px;
  margin-left: 10px;
  width: 70px;
  color: white;
}

table img {
  width: 140px;
  height: 140px;
}

.xiaoshou {
  cursor: pointer;
}

/*滚动条样式start*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}

::-webkit-scrollbar-thumb {
  min-height: 28px;
  padding-top: 100;
  height: 200px;
  /* background-image: linear-gradient(rgba(13, 15, 43, 0.5), rgba(63, 72, 204, 0.5)); */
  background-image: linear-gradient(rgba(63, 72, 204, 0.5),
      rgba(13, 15, 43, 0.5));
  /* background-image: linear-gradient(rgba(63, 72, 204, 0.5), #9198e5); */
  /* background-color: rgba(63, 72, 204, 0.5); */
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border-radius: 5px;
  -webkit-box-shadow: inset 1px 1px 0 rgba(63, 72, 204, 0.5);
}

.over1::-webkit-scrollbar-thumb {
  min-height: 28px;
  padding-top: 100;
  height: 200px;
  background-image: linear-gradient(rgba(63, 72, 204, 0.5), #9198e5);
  /* background-color: rgba(63, 72, 204, 0.5); */
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border-radius: 5px;
  -webkit-box-shadow: inset 1px 1px 0 rgba(63, 72, 204, 0.5);
}

/*滚动条样式end*/
</style>


// WEBPACK FOOTER //
// src/view/zkjg.vue